const Footer = () => {
  return (
    <footer
      className="px-6 py-12"
      style={{
        background: "rgba(237,234,230,0.75)",
        borderTop: "1px solid rgba(26,38,22,0.06)",
      }}
    >
      <div className="max-w-5xl mx-auto">
        <div className="flex flex-col md:flex-row justify-between items-start gap-8 mb-10">
          <div>
            <div className="flex items-center gap-0 mb-3">
              <img
                src="/foreman-logo-new.png"
                alt=""
                className="h-16 w-16 -my-3 -mr-3"
                style={{ objectFit: "contain" }}
              />
              <span
                style={{
                  fontSize: "20px",
                  fontWeight: 500,
                  color: "#1a2616",
                  fontFamily: "'Clash Grotesk', -apple-system, BlinkMacSystemFont, sans-serif",
                }}
              >
                Foreman
              </span>
            </div>
            <p
              style={{
                fontSize: "13px",
                color: "rgba(26,38,22,0.75)",
                maxWidth: "260px",
                lineHeight: 1.6,
              }}
            >
              The AI employee that handles your trade admin. Built for
              construction, plumbing, electrical, and field service businesses.
            </p>
          </div>

          <div className="flex gap-12">
            <div>
              <p
                style={{
                  fontSize: "11px",
                  fontWeight: 600,
                  letterSpacing: "0.12em",
                  textTransform: "uppercase" as const,
                  color: "rgba(26,38,22,0.75)",
                  marginBottom: "12px",
                }}
              >
                Product
              </p>
              <ul className="space-y-2">
                {[
                  ["How it works", "#how-it-works"],
                  ["Pricing", "#pricing"],
                  ["Demo", "#product"],
                ].map(([label, href]) => (
                  <li key={label}>
                    <a
                      href={href}
                      className="transition-colors duration-200"
                      style={{ fontSize: "14px", color: "rgba(26,38,22,0.75)" }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.color = "#1a2616";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.color = "rgba(26,38,22,0.75)";
                      }}
                    >
                      {label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <p
                style={{
                  fontSize: "11px",
                  fontWeight: 600,
                  letterSpacing: "0.12em",
                  textTransform: "uppercase" as const,
                  color: "rgba(26,38,22,0.75)",
                  marginBottom: "12px",
                }}
              >
                Company
              </p>
              <ul className="space-y-2">
                {[
                  ["Privacy", "/privacy"],
                  ["Terms", "/terms"],
                  ["Which Foreman?", "/articles/which-foreman-is-which"],
                ].map(([label, href]) => (
                  <li key={label}>
                    <a
                      href={href}
                      className="transition-colors duration-200"
                      style={{ fontSize: "14px", color: "rgba(26,38,22,0.75)" }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.color = "#1a2616";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.color = "rgba(26,38,22,0.75)";
                      }}
                    >
                      {label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        <div
          className="pt-6 flex flex-col md:flex-row justify-between items-center gap-3"
          style={{ borderTop: "1px solid rgba(26,38,22,0.06)" }}
        >
          <p style={{ fontSize: "12px", color: "rgba(26,38,22,0.75)" }}>
            © {new Date().getFullYear()} Foreman AI Limited. All rights reserved.
          </p>
          <p style={{ fontSize: "12px", color: "rgba(26,38,22,0.5)" }}>
            <a href="mailto:owen@askforeman.co.uk" style={{ color: "rgba(26,38,22,0.75)", textDecoration: "none" }}>owen@askforeman.co.uk</a>
            <span style={{ margin: "0 8px" }}>·</span>
            Built in the UK 🇬🇧
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
